import CustomSegment from "../../../../components/CustomSegment";
import PageTitle from "../../../../components/PageTitle";
import { useSegment } from "../../../../hooks/useSegment";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import type { SegmentedType } from "../../../../types/global.types";
import Filters from "./_components/Filters";
import CustomFields from "./CustomFields";
import Departments from "./Departments";
import Designations from "./Designations";
// import Grades from "./Grades";
import Offices from "./Offices";

export type OrganizationSegmentType =
  | "departments"
  | "designations"
  | "grades"
  | "offices"
  | "custom-fields";

const Organization = () => {
  const { segment, setSegment } = useSegment<OrganizationSegmentType>(
    "control-panel-organization",
    "offices",
    false
  );
  const SEGMENT_CONFIG: SegmentedType<OrganizationSegmentType>[] = [
    {
      value: "offices",
      label: "Offices",
      view: <Offices />,
    },
    {
      value: "departments",
      label: "Departments",
      view: <Departments />,
    },
    {
      value: "designations",
      label: "Designations",
      view: <Designations />,
    },
    {
      value: "custom-fields",
      label: "Custom Fields",
      view: <CustomFields />,
    },
    // {
    //   value: "grades",
    //   label: "Grades",
    //   view: <Grades />,
    // },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Organization">
      <PageTitle
        classNames={{ root: "items-start" }}
        title="Organization"
        items={[
          { title: "Dashboard", path: "/admin/control-panel/dashboard" },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default Organization;
